// material-ui
import { useTheme } from "@mui/material/styles";
import { Avatar, Box } from "@mui/material";

// project imports
import Logo from 'ui-component/Logo';
import ProfileSection from "./ProfileSection";
import { useDispatch, useSelector } from "store";
import { openDrawer } from "store/slices/menu";
import { Link, useNavigate } from "react-router-dom";


// assets
import { IconMenu2 } from "@tabler/icons";
import { DASHBOARD_PATH } from "config";

// ==============================|| MAIN NAVBAR / HEADER ||============================== //

const Header = () => {
  const theme = useTheme();

  const dispatch = useDispatch();
  const navigate = useNavigate()
  const { drawerOpen } = useSelector((state) => state.menu);

  return (
    <>
      {/* logo & toggler button */}
      <Box
        sx={{
          width: 228,
          display: "flex",
          alignItems: "center",
          [theme.breakpoints.down("md")]: {
            width: "auto",
          },
        }}
      >
        <Box
          component="span"
          sx={{ display: { xs: "none", md: "block" }, flexGrow: 1 , cursor: 'pointer' }}
          onClick={()=> navigate(DASHBOARD_PATH, { replace: true })}
        >
          <Logo width={"170px"} />
        </Box>
        <Avatar
          variant="rounded"
          sx={{
            ...theme.typography.commonAvatar,
            ...theme.typography.mediumAvatar,
            overflow: "hidden",
            transition: "all .2s ease-in-out",
            // background: "#DEF5FD",
            backgroundColor:
              theme.palette.mode === "dark"
                ? theme.palette.dark.main
                : theme.palette.primary.light,
            color: "#00AEEF !important",
            "&:hover": {
              background: "#00AEEF  !important",
              color: "#fff !important",
            },
          }}
          onClick={() => dispatch(openDrawer(!drawerOpen))}
          color="inherit"
        >
          <IconMenu2 stroke={1.5} size="1.3rem" />
        </Avatar>
      </Box>
      <Box sx={{ flexGrow: 1 }} />
      <Box sx={{ flexGrow: 1 }} />

      {/* Profile Section Menu */}
      <Link to={"/update-profile"}>
        <ProfileSection />
      </Link>
    </>
  );
};

export default Header;
